import { useSearchParams } from 'react-router-dom';
import { Language } from '../enums/common';
import { taraStatus } from '../utils/conversation';
import logger from '../utils/logger';
import { taraPwaHelper } from '../utils/pwa';

enum Event {
    TARA_PERFORM_ACTION = 'TARA_PERFORM_ACTION',
    TARA_DISMISS_VIEW = 'TARA_DISMISS_VIEW',
}

const submit =
    // eslint-disable-next-line no-script-url
    'javascript:window.postMessage({ type: "taraMessageVideo", query: "USER_QUERY", mode: "MODE" }, "*")';

let isEnableActions = false;
let isMounted = false;

export const useNativeFooter = () => {
    const { trigger } = taraPwaHelper;
    const [searchParams] = useSearchParams();
    const lang = (searchParams.get('lang') as Language) || Language.EN;

    const disableActions = () => {
        if (!isMounted || !isEnableActions) return;

        isEnableActions = false;

        trigger(Event.TARA_PERFORM_ACTION, {
            enableActions: false,
            playVideo: null,
            showIntroduction: false,
            showTooltip: false,
            showVideo: taraStatus.isEnabled(),
            submit,
        });
    };

    const enableActions = () => {
        if (!isMounted || isEnableActions) return;

        isEnableActions = true;

        const { isEnabled, isIntroduced, isNudged, nudge } = taraStatus;
        const enabled = isEnabled();
        const showIntroduction = !isIntroduced();
        const showTooltip = !isNudged();
        const eventName = Event.TARA_PERFORM_ACTION;
        const params: Parameters<typeof trigger>[1] = {
            enableActions: true,
            lang,
            mode: enabled ? undefined : 'TEXT',
            playVideo: showIntroduction ? 'intro' : null,
            showIntroduction,
            showTooltip,
            showVideo: enabled,
            submit,
        };

        trigger(eventName, params);
        logger({ id: 'BRIDGE-EVENT-TRIGGER-ACTIONS', type: 'info', eventName, params });

        if (showTooltip) nudge();
    };

    const mount = () => {
        isMounted = true;

        const eventName = Event.TARA_PERFORM_ACTION;
        const params = {
            enableActions: false,
            playVideo: null,
            showIntroduction: false,
            showTooltip: false,
            showVideo: taraStatus.isEnabled(),
            submit,
        };

        trigger(eventName, params);
        logger({ id: 'BRIDGE-EVENT-TRIGGER-MOUNT', type: 'info', eventName, params });
    };

    const pause = () => {
        if (!isMounted) return;

        trigger(Event.TARA_PERFORM_ACTION, {
            enableActions: isEnableActions,
            playVideo: null,
            showIntroduction: false,
            showTooltip: false,
            showVideo: taraStatus.isEnabled(),
            submit,
        });
    };

    const play = (url: string) => {
        if (!isMounted || !taraStatus.isEnabled()) return;

        const eventName = Event.TARA_PERFORM_ACTION;
        const params: Parameters<typeof trigger>[1] = {
            enableActions: isEnableActions,
            lang,
            mode: 'SPEECH',
            playVideo: url,
            showIntroduction: false,
            showTooltip: false,
            showVideo: true,
            submit,
        };

        trigger(eventName, params);
        logger({ id: 'BRIDGE-EVENT-TRIGGER-PLAY', type: 'info', eventName, params });
    };

    const unmount = () => {
        if (!isMounted) return;

        isMounted = false;

        const eventName = Event.TARA_DISMISS_VIEW;
        const params = {
            enableActions: false,
            playVideo: null,
            showIntroduction: false,
            showTooltip: false,
            showVideo: false,
            submit,
        };

        trigger(eventName, params);
        logger({ id: 'BRIDGE-EVENT-TRIGGER-UNMOUNT', type: 'info', eventName, params });
    };

    return { disableActions, enableActions, mount, pause, play, unmount };
};
